import React, { FC } from "react";
import { LocalizationLanguage } from "@green0meter/api-client";

import { Button, Grid } from "@components/base";

interface LanguageTabs {
  language: LocalizationLanguage;
  setLanguage: (language: LocalizationLanguage) => void;
}

const LanguageTabs: FC<LanguageTabs> = ({ language, setLanguage }) => (
  <Grid container spacing={1}>
    {(
      Object.values(LocalizationLanguage).filter(
        (value) => typeof value === "number",
      ) as LocalizationLanguage[]
    ).map((value) => {
      const langKey = LocalizationLanguage[value].toLowerCase();

      return (
        <Grid key={langKey}>
          <Button
            variant={language === value ? "contained" : "outlined"}
            onClick={() => setLanguage(value)}
            size="small"
          >
            {langKey}
          </Button>
        </Grid>
      );
    })}
  </Grid>
);

export default LanguageTabs;
